import { EventBus, GameEvents } from '../utils/EventBus'
import { writeAutoSave } from '@/systems/SaveSystem'

// Rolling auto-save. Snapshots the live game into a dedicated slot on day
// changes (throttled, so fast-forwarding doesn't hammer localStorage) and
// always on week changes as a guaranteed checkpoint. The snapshot shows up
// alongside the manual slots in Ajustes > Partidas guardadas and is loadable
// like any other save. Registered LAST in GameDirector so its DAY_CHANGED
// handler runs after the other systems have applied the day's changes.
const MIN_INTERVAL_MS = 10_000

export class AutoSaveSystem {
  private boundHandlers: { event: string; handler: () => void }[] = []
  private lastSaveAt = 0

  constructor() {
    this.setupListeners()
  }

  private listen(event: string, handler: () => void) {
    EventBus.on(event, handler)
    this.boundHandlers.push({ event, handler })
  }

  private save(force = false) {
    const now = Date.now()
    if (!force && now - this.lastSaveAt < MIN_INTERVAL_MS) return
    this.lastSaveAt = now
    writeAutoSave()
  }

  private setupListeners() {
    this.listen(GameEvents.DAY_CHANGED, () => this.save())
    this.listen(GameEvents.WEEK_CHANGED, () => this.save(true))
  }

  destroy() {
    for (const { event, handler } of this.boundHandlers) {
      EventBus.off(event, handler)
    }
    this.boundHandlers = []
  }
}
